import React, { useEffect, useRef, useState } from "react";
import Layout from "../components/Layout";
import Container from '@mui/material/Container';
import { useParams } from "react-router"
import { useDispatch, useSelector } from "react-redux";
import { fetchPolicyDetails } from "../redux/actions/policyAction";
import PolicyCard from "../components/PolicyCard";
import PolicyDetails from "../components/PolicyDetails";
import AdditionalInfo from "../components/AdditionalInfo";
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import LoanCard from "../components/LoanCard";
import AssignmentCard from "../components/Assignment";
import PremiumFinancingCard from "../components/PremiumFinancingCard";
import RevivalOption from "../components/RevivalOption";
import Loader from "../components/Loader";
import Graph from "../components/Graph";
import { pathOr } from "ramda";
import OtpInputs from 'react-otp-input';
import { Button } from "@mui/material";
const UserEligibility = () => {
    const { id } = useParams()
    const dispatch = useDispatch();
    const policy = useSelector(state => state.Policy.policyInfo)
    const loading = useSelector(state => state.Loader.loader);
    const [isOtpVerified, setOtpVerified] = useState(false);
    const [otp, setOtp] = useState('');
    const otpRef = useRef()
    useEffect(() => {
       dispatch(fetchPolicyDetails({ policyNumber: id }))
    }, [id])
    const otpVerification =  () => {
        if(otp == '987654'){
            setOtpVerified(true)
        }
    }
    const handleOtp = async code => {
        setOtp(code);
        if (code.length === 6) {
        //     debugger;
        //     if (otpRef.current)
        // otpRef.current.blur();
        if(code == '987654'){
            setOtpVerified(true)
        }
    }
  };
    return (
        <Layout>
            {loading ? (
                <Container maxWidth="sm" style={{ padding: 30, backgroundColor: 'white', borderRadius: 12 }}>
                    <Loader />
                </Container>
            ) : isOtpVerified ?  (<Container maxWidth="sm" style={{ padding: 30, backgroundColor: 'white', borderRadius: 12 }}>
                <PolicyCard policy={policy} />
                <PolicyDetails policy={policy} />
                <AdditionalInfo policy={policy} />
                {policy.savingType === 'ULIP' && policy.policyStatus !== 'Inforce' && (
                    <Graph policy={policy} />
                )}
                <Paper elevation={3} style={{ paddingTop: 30, paddingBottom: 30, paddingLeft: 24, paddingRight: 24, backgroundColor: '#FAFAFA', borderColor: '#FAFAFA', borderWidth: 1, borderStyle: 'solid', borderRadius: 8, marginTop: 30 }}>
                    <div mb={8}>
                        <Typography color='#4DA235' variant='h5'>Congratulations !</Typography>
                        <Typography variant='caption'>YOUR POLICY ELIGIBLE FOR</Typography>
                    </div>
                    { pathOr(false, ['loanInfo', 'isLoanOnInsuranceEligible'], policy) && (
                        <LoanCard policy={policy} user={true} />
                    )}
                    {pathOr(false, ['loanInfo', 'isAssignmentEligible'], policy) && (
                        <AssignmentCard policy={policy} user={true} />
                    )}
                    {pathOr(false, ['loanInfo', 'isPremiumFinanceEligible'], policy) && (
                        <PremiumFinancingCard policy={policy} user={true} />
                    )}
                    {policy.savingType !== 'ULIP' && policy.policyStatus !== 'Inforce' && (
                    <RevivalOption policy={policy} user={true} />
                    )}
                </Paper>
            </Container>) : (
                 <div style={{textAlign:'center'}}>
                 <Typography className='regular' variant='subtitle2' style={{}}>
                     Enter  6 digit verfication code
                     sent to your registered mobile number
                      
                 </Typography>
                 <div style={{textAlign:'center'}}>
                     <OtpInputs
                         onChange={(code) => {
                             handleOtp(code);
                         }}
                        // ref={otpRef}
                         inputType={'tel'}
                         value={otp}
                         shouldAutoFocus={true}
                         isInputNum={true}
                         numInputs={6}
                         containerStyle={{
                             flex: 1,
                             justifyContent:'center'
                         }}
                         inputStyle={"otpInputField"}
                         renderInput={(props) => <input ref={otpRef} {...props} />}
                         />
                 </div>
                 <div style={{marginTop:'24px',textAlign:'center',marginBottom:'24px'}}>
                    <Button disabled={otp.length !== 6 ? true : false} onClick={()=>{otpVerification()}} variant="contained" color="success" size="medium"  sx={{ width: 200, padding: 1, margin: 2 }}>Next</Button>
                </div> 
             </div>
            )}

        </Layout>
    )
}

export default UserEligibility